import React from "react";

const OnboardingStepHeader = ({ text }) => {
  return <h4 className="mt-4 mb-4">{text}</h4>;
};

export default OnboardingStepHeader;
